module.exports = __webpack_public_path__ + "static/img/about_bg_02_zh.156cc2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_bg_02_zh.png
// module id = 0UP4
// module chunks = 34